<template>
  <div v-show="availableTeleports.includes(placement)" :id="placement" />
</template>

<script setup>
import { ADDITIONAL_PARAMS_FIELDS_PLACEMENTS } from '@/utils/custom-fields/factory'
import { includesValue } from '@/utils/prop-validators'

defineProps({
  availableTeleports: {
    type: Array,
    required: true
  },

  placement: {
    type: String,
    required: true,
    validator: v => includesValue(v, ADDITIONAL_PARAMS_FIELDS_PLACEMENTS)
  }
})
</script>

<style lang="scss" scoped></style>
